// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"_3FoS5Y","inline":"_1-Y07h","block":"efMxCT","fullWidth":"Xu0-WL","trigger":"_2pXa7L","button":"UBwSae","icon":"_2Tx2Yh","icon--disabled":"_2JPnT3"};